export interface ForecastTableRow {
  month: string;
  forecast2526: number;
  mlPrediction2526?: number; // <-- Make this optional
  history2425: number;
  history2324: number;
  history2223: number;
  agg_history2425: number;
  agg_history2223: number;
  tot_demand2526: number;
  updatedFields?: Record<string, boolean>;
}

export interface ForecastChartData {
  months: string[];
  forecast2526: number[];
  mlPrediction2526?: number[]; // ✅ Mark it optional
  history2425: number[];
  history2324: number[];
  history2223: number[];
  aggHistory2425: number[];
  aggHistory2223: number[];
  totalDemand2526: number[];
}

export interface ForecastData {
  tableData: ForecastTableRow[];
  chartData: ForecastChartData;
}

export interface DemandData {
  currentPlanPeriod?: string;
  items?: DemandItem[];
  periodNames?: string[];
  [property: string]: any;
}

export interface DemandItem {
  records?: DemandItemRecord[];
  type?: DemandType;
  years?: number[];
  [property: string]: any;
}
export interface DemandItemRecord {
  adjustment?: null | Adjustment;
  period?: PeriodInfo;
  rawValue?: number;
  [property: string]: any;
}

export interface Adjustment {
  createdAt?: Date;
  createdBy?: string;
  notes?: string;
  value?: number;
  [property: string]: any;
}

export interface PeriodInfo {
  name?: string;
  value?: string;
  year?: string;
  [property: string]: any;
}

export enum DemandType {
  AggForecast = 'agg_forecast',
  AggHistory = 'agg_history',
  AggTotDemand = 'agg_tot_demand',
  Forecast = 'forecast',
  History = 'history',
  TotDemand = 'tot_demand'
}
//forecast adjustment history response
export interface ForecastAdjustmentHistoryResponse {
  items: AdjustmentHistoryItem[];
  pagination: CursorPaginationResponse;
  [property: string]: any;
}
export interface AdjustmentHistoryItem {
  createdAt: string;
  createdBy: string;
  period: PeriodInfo;
  rawValue: number;
  systemDoc?: null | string;
  userDoc?: null | string;
  value: number;
  [property: string]: any;
}

export interface CursorPaginationResponse {
  nextCursor: null | string;
  size: number;
  [property: string]: any;
}
